import { RequisitesActionType } from "../../Engine/Externals/Requisites/Store/RequisitesActions";
import { IForm, RequisitesInfo } from "../../Engine/Form/IForm";

export function loadRequisitesIntoForm(form: IForm, requisites: RequisitesInfo): void {
    form.store.dispatch({ type: RequisitesActionType.LoadInitialRequisites, payload: requisites });
    form.requisites = requisites;
}
